; (function ($) {

    window.addEventListener('DOMContentLoaded', () => {
        partnersFilterUI()
    })


    const partnersFilterUI = () => {
        const renderTarget = document.querySelector('.partner-grid-container')
        const filterNavElements = document.querySelectorAll('.filter-nav [data-id]')
        const groups = document.querySelectorAll('.colab-group')

        currentFilterId = null

        filterNavElements.forEach((el) => {
            el.addEventListener('click', (ev) => {
                if ( currentFilterId === el.dataset.id) return
                if (currentFilterId) {
                    const elSelected = document.querySelector(`.filter-nav [data-id="${currentFilterId}"]`)
                    elSelected.classList.remove('selected')
                }
                currentFilterId = el.dataset.id
                el.classList.add('selected')

                if (currentFilterId) {
                    groups.forEach(el => {
                        if (el.dataset.group_id === currentFilterId) {
                            el.classList.add('show')
                        }
                        else {
                            el.classList.remove('show')
                        }
                    })
                }

            })

        })


        // console.log(groups[0].className)
    }


})(jQuery)
